<script setup>
import DataGrid from "@/components/common/other/DataGrid";
import Button from "@/components/common/input/Button";
import Notification from "@/classes/component-classes/Notification";

import {inject} from 'vue';
import axios from "axios";
import {useRoute} from "vue-router";
import API from "@/classes/global/API";

const route = useRoute();
const shipments = inject("shipments");

async function prepareModal(row) {

  shipments.value.warehousePicksModal = true;
  shipments.value.warehousePicks.selectedShipmentItem = row;

  const response = await API.getWarehouseItems(route, row.warehouseRef);

  if(response) {

    shipments.value.viewShipment.warehouseItems = response;
  }

}

</script>

<template>

    <DataGrid
        :key="shipments.viewShipment.warehouseHeaders.length"
        height="196"
        :selectable="false"
        :row-selection="false"
        :allow-grid-menu="false"
        :allowPagination="false"
        :dataSource="shipments.viewShipment.warehouseHeaders"
        :columns="shipments.warehouseShipmentDetail.gridColumns">
      <template v-slot:viewPick="row">
        <Button
            @click="prepareModal(row.rowData)"
            type="toolbar"
            text="View">
        </Button>
      </template>
      <template v-slot:moreDetail="row">
        <Button
            @click="prepareModal(row.rowData)"
            type="toolbar"
            text="Details">
        </Button>
      </template>
    </DataGrid>

</template>

<style scoped>

</style>
